<template>
    <section class="inner-article-container bg-fadeblue">
        <div class="page-container">
            <div class="heading">
                <h2 class="heading__h3 left">Featured Offers</h2>
            </div>
            <VueSlickCarousel v-if="this.featuredOffers && this.featuredOffers.length" v-bind="settings" class="three-slider">

                <div v-for="(item, index) in this.featuredOffers" :key="item.OfferId+index">
                    <div class="">
                        <landing-page-offer-component :key="item.OfferId" :offer="item"> </landing-page-offer-component>
                    </div>
                </div>
            </VueSlickCarousel>

        </div>
    </section>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import LandingPageOfferComponent from './LandingPageOfferComponent.vue'

    export default {
        name: "FeaturedOffersSliderComponent",
        components: {
            VueSlickCarousel,
            LandingPageOfferComponent
        },
        props: ['featuredOffers'],
        data() {
            return {
                settings: {
                    infinite: true,
                    autoplay: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    pauseOnHover: true,
                    speed: 500,
                    arrows: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                },
            }
        },

        mounted() {

            // console.log(this.featuredOffers, 'featured offers');
        },
        watch: {

            featuredOffers: function (val) {
                // console.log(val, 'featured offers 2');
            }
        }
    }
</script>
